import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import ResponsiveDrawer from '../Drawer/drawer';
import Toolbar from '@mui/material/Toolbar';
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/GetApp';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { generateOrderPDF } from './PDFGenerator';

const PDFPreview = () => {
    const drawerWidth = 240;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [pdfUrl, setPdfUrl] = useState(null);
    const pdfDocRef = useRef(null);
    const currentUrlRef = useRef(null);

    const getMockDraft = () => {
        // Draw a mock white signature on a #4DB6AC teal background using a temporary offscreen canvas
        const canvas = document.createElement('canvas');
        canvas.width = 400;
        canvas.height = 160;
        const ctx = canvas.getContext('2d');

        ctx.fillStyle = '#4DB6AC';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 5;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo(40, 90);
        ctx.bezierCurveTo(90, 30, 140, 130, 190, 80);
        ctx.bezierCurveTo(240, 30, 290, 130, 360, 70);
        ctx.stroke();

        const mockSignatureBase64 = canvas.toDataURL("image/png");

        return {
            selectedCustomer: {
                StoreName: "14TH AVENUE SHOES",
                customerid: "2052",
                firstname: "AKIVA",
                lastname: "BITTMAN",
                email_1: "shoes4311@gmail.com",
                email_2: "",
                cell_1: "7188128972"
            },
            cartItems: [
                { sku: "W26-M0036", styleFactory: "55-REESE2", color_on_box: "003 BLACK OIL", product_img: "http://localhost:3004/shoe.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 19, unitQuantity: 74, unitFinalPrice: 50.75 },
                { sku: "W26-M0010", styleFactory: "55-REESE", color_on_box: "002 BLACK PAT", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 22, unitQuantity: 23, unitFinalPrice: 50.75 },
                { sku: "W26-M0055", styleFactory: "55-REESE3", color_on_box: "001 WHITE", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 23, unitQuantity: 18, unitFinalPrice: 50.75 },
                { sku: "W26-M0060", styleFactory: "55-REESE4", color_on_box: "004 NAVY", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 24, unitQuantity: 65, unitFinalPrice: 50.75 },
                { sku: "W26-M0070", styleFactory: "55-REESE5", color_on_box: "005 BROWN", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 25, unitQuantity: 29, unitFinalPrice: 50.75 },
                { sku: "W26-M0080", styleFactory: "55-REESE6", color_on_box: "006 TAN", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 26, unitQuantity: 12, unitFinalPrice: 50.75 },
                { sku: "W26-M0090", styleFactory: "55-REESE7", color_on_box: "007 GREY", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 27, unitQuantity: 19, unitFinalPrice: 50.75 },
                { sku: "W26-M0100", styleFactory: "55-REESE8", color_on_box: "008 RED", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 28, unitQuantity: 3, unitFinalPrice: 51.75 },
                { sku: "W26-M0110", styleFactory: "55-REESE9", color_on_box: "009 GREEN", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 29, unitQuantity: 8, unitFinalPrice: 51.75 },
                { sku: "W26-M0120", styleFactory: "55-REESE10", color_on_box: "010 PURPLE", product_img: "http://localhost:3004/shoes.jpg", Price1: 50.75, Price2: 51.75, Price3: 52.75, size: 30, unitQuantity: 14, unitFinalPrice: 51.75 },
            ],
            shippingDetails: {
                paymentTerm: "CREDIT CARD",
                startDate: "18-06-2026",
                cancelDate: "18-07-2026",
                shippingAddress: {
                    storeName: "14TH AVENUE SHOES",
                    address1: "4311 14TH AVENUE",
                    address2: "BROOKLYN, NY, 11219",
                    city: "BROOKLYN",
                    state: "NY",
                    postcode: "11219",
                    country: "USA"
                },
                billingAddress: {
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    postcode: "",
                    country: ""
                }
            },
            signature: mockSignatureBase64
        };
    };

    const renderPDF = async () => {
        setLoading(true);
        try {
            const mockDraft = getMockDraft();
            const orderNumber = "986293";
            const orderDateStr = new Date().toISOString().split('T')[0];

            const doc = await generateOrderPDF(mockDraft, orderNumber, orderDateStr);
            pdfDocRef.current = doc;

            const pdfBlob = doc.output('blob');
            const newUrl = URL.createObjectURL(pdfBlob);

            if (currentUrlRef.current) {
                URL.revokeObjectURL(currentUrlRef.current);
            }
            currentUrlRef.current = newUrl;
            setPdfUrl(newUrl);
        } catch (error) {
            console.error("PDF Preview generation failed:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        renderPDF();

        return () => {
            if (currentUrlRef.current) {
                URL.revokeObjectURL(currentUrlRef.current);
            }
        };
    }, []);

    const handleDownload = () => {
        if (pdfDocRef.current) {
            pdfDocRef.current.save("14TH AVENUE SHOES_986293.pdf");
        }
    };

    const handleOpenInNewTab = () => {
        if (pdfUrl) {
            window.open(pdfUrl, '_blank');
        }
    };

    return (
        <div className="mx-4">
            <ResponsiveDrawer heading="Live PDF Preview Sandbox" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    p: 3
                }}
                component="main"
            >
                <Toolbar />

                {/* Control Header */}
                <Paper
                    sx={{
                        p: 2.5,
                        mb: 3,
                        borderRadius: 2,
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate('/TestPDF')}
                            sx={{ borderRadius: 1.5 }}
                        >
                            Sandbox
                        </Button>
                        <Box>
                            <Typography variant="h6" fontWeight="bold" color="primary">
                                Live PDF Preview
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Directly view layout alignment without downloading files.
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <RefreshIcon />}
                            onClick={renderPDF}
                            disabled={loading}
                            sx={{ borderRadius: 1.5, fontWeight: 'bold' }}
                        >
                            {loading ? "Rendering..." : "Refresh Preview"}
                        </Button>

                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<OpenInNewIcon />}
                            onClick={handleOpenInNewTab}
                            disabled={!pdfUrl || loading}
                            sx={{ borderRadius: 1.5 }}
                        >
                            Open in Tab
                        </Button>

                        <Button
                            variant="outlined"
                            color="success"
                            startIcon={<DownloadIcon />}
                            onClick={handleDownload}
                            disabled={!pdfDocRef.current || loading}
                            sx={{ borderRadius: 1.5 }}
                        >
                            Download PDF
                        </Button>
                    </Box>
                </Paper>

                {/* PDF Viewer Container */}
                <Box
                    sx={{
                        flexGrow: 1,
                        width: '100%',
                        height: 'calc(100vh - 220px)',
                        minHeight: '750px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: '#f5f5f7',
                        borderRadius: 2,
                        overflow: 'hidden',
                        boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)',
                        border: '1px solid rgba(0,0,0,0.08)'
                    }}
                >
                    {loading ? (
                        <Box sx={{ textAlign: 'center', py: 8 }}>
                            <CircularProgress size={48} sx={{ mb: 2 }} />
                            <Typography variant="h6" color="text.secondary">
                                Generating PDF Layout Preview...
                            </Typography>
                        </Box>
                    ) : pdfUrl ? (
                        <iframe
                            src={pdfUrl}
                            title="Order PDF Live Preview"
                            width="100%"
                            height="100%"
                            style={{
                                border: 'none',
                                display: 'block',
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    ) : (
                        <Typography color="error">
                            Failed to load PDF preview.
                        </Typography>
                    )}
                </Box>
            </Box>
        </div>
    );
};

export default PDFPreview;
